import { useAbility } from '@casl/react'

import { AbilityContext } from '@/lib/auth/abilityContext'

export const usePermissions = () => {
  const { can, cannot } = useAbility(AbilityContext)

  return { can, cannot }
}
